import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import * as constants from 'src/constant.json';
import { CmaState } from '../cma.state';
@Component({
  selector: 'app-property-search-address',
  templateUrl: './property-search-address.component.html',
  styleUrls: ['./property-search-address.component.scss'],
})
export class PropertySearchAddressComponent implements OnInit {
  constructor(private formBuilder: FormBuilder, private cmaState: CmaState, private snackbar: MatSnackBar) { }

  searchAddressForm: FormGroup;
  constant: any = constants;
  upgradeSnackbar: MatSnackBarRef<any>;

  initialValues: {};
  onDestroyNotifier$ = new Subject();

  ngOnInit(): void {
    this.searchAddressForm = this.formBuilder.group({
      streetNumber: null,
      streetName: null,
      unitNumber: null,
      city: null,
      state: null,
      zip: null,
    });
    this.initialValues = this.searchAddressForm.value;
  }

  addressSearch() {
    let formValues = this.searchAddressForm.value;

    if (formValues.streetNumber || formValues.streetName) {
      if ((formValues.city && formValues.state) || formValues.zip) {
        let addressObj: any = {
          StreetNumber: formValues.streetNumber,
          StreetName: formValues.streetName,
          City: formValues.city,
          State: formValues.state,
          Zip: formValues.zip,
          ListingsOnly: true,
          pagenumber: 1,
          pagesize: 20,
        };
        this.cmaState.searchPropertyValue = this.filterInputJson(addressObj);
      } else {
        this.openSnackbar('City and State or Zip is mandatory', false);
      }
    } else {
      this.openSnackbar('StreetNumber or StreetName is mandatory', false);
    }
  }

  resetSearchFilter() {
    this.searchAddressForm.reset(this.initialValues);
    this.cmaState.searchAddressValue = null;
    this.cmaState.searchPropertyValue = null;
    this.cmaState.listPropertySetValue = null;
    this.cmaState.listPropertySetCount = null;
  }

  ngOnDestroy(): void {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }

  openSnackbar(upgradeMsg, success = false) {
    this.upgradeSnackbar = this.snackbar.open(upgradeMsg, 'Dismiss', {
      duration: 5000,
      panelClass: [success ? 'snackbar-success' : 'snackbar-error'],
      verticalPosition: 'top',
    });
  }

  filterInputJson(obj) {
    Object.keys(obj).forEach((key) => {
      if (obj[key] == null) {
        delete obj[key];
      }
    });
    return obj;
  }
}
